import { useState, useEffect } from "react";
import { useMutation, useQuery } from "react-query";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
//prime React
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
//components
import Input from "../../../../components/input/Input";
import Toggle from "../../../../components/button/Toggle";
import Select from "../../../../components/input/Select";
import CardProfile from "../../../../components/upload/CardProfile";
//services
import { getIndex } from "../../../../services/GlobalRoles/getIndex";
import { putEnterprise } from "../../../../services/Enterprise/putEnterprise";
//utils
import { queryClient } from "../../../../utils/queryClient";
import { useAppContext } from "../../../../context/AppContext";

export default function EditEnterprise({
  id,
  oneEnterprise,
  loadingEnterprise,
}) {
  const { permissions } = useAppContext();
  const [file, setFile] = useState("");
  const [loading, setLoading] = useState(false);
  const [defaultValues, setDefaultValues] = useState({});

  useEffect(() => {
    if (oneEnterprise) {
      // console.log(oneEnterprise);
      const logoVerify = oneEnterprise.logo?.path || "";
      setDefaultValues({
        title: oneEnterprise.title,
        matricula: oneEnterprise.matricula,
        logo: logoVerify,
        index_id: oneEnterprise.index.id,
        enableReportDimob: oneEnterprise.enable_report_dimob,
        ...(permissions?.includes("195") && { show_app: oneEnterprise.show_app || false }),
        ...(permissions?.includes("195") && { show_files_app: oneEnterprise.show_files_app || false }),
      });
    }
  }, [oneEnterprise]);

  const form = useForm({ defaultValues });
  const errors = form.formState.errors;

  const { data: index, isLoading: loadingIndex } = useQuery({
    queryKey: ["index"],
    queryFn: () => getIndex(),
    enabled: !!permissions?.includes("149"),
  });

  const { mutateAsync: putEnterpriseFn } = useMutation({
    mutationFn: putEnterprise,
    onSuccess(_, variables) {
      queryClient.setQueryData([`oneEnterprise${id}`], (data) => {
        data.title = variables.title;
        data.matricula = variables.matricula;
        data.enable_report_dimob = variables.enable_report_dimob;
        return data;
      });
    },
    onError(error) {
      //      console.log(error);
    },
  });

  useEffect(() => {
    form.setValue("title", defaultValues.title);
    form.setValue("matricula", defaultValues.matricula);
  }, [form, defaultValues]);

  const handleFileChange = (file) => {
    setFile(file);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const notification = toast.loading("Por favor aguarde...");
    data.enterprise_id = id;
    if (data.index_id === undefined) {
      data.index_id = defaultValues.index_id;
    }
    if (data.enable_report_dimob === undefined) {
      data.enable_report_dimob = defaultValues.enableReportDimob;
    }

    if(permissions?.includes("195")) {
      if (data.show_app === undefined) {
        data.show_app = defaultValues.show_app;
      }
      if (data.show_files_app === undefined) {
        data.show_files_app = defaultValues.show_files_app;
      }
    }

    if (file !== "") {
      data.file = file.setFile;
    }
    try {
      await putEnterpriseFn(data);

      toast.update(notification, {
        render: "Informação salva com sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Houve um erro a cadastrar as informações!",
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    }
    setLoading(false);
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  return (
    <>
      {/* Notification  */}

      {/* End Notification  */}
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="row">
          <div className="row col-lg-3 col-xl-3  mt-5 my-auto">
            <CardProfile
              name="profile_photo"
              control={form.control}
              preValue={defaultValues.logo !== "" && defaultValues.logo}
              onPhotoUpload={handleFileChange}
              setValue={form.setValue}
            />
            {/* <Logo onFileChange={handleFileChange} /> */}
          </div>
          <div className="row d-flex col-xl-9 col-lg-9 mt-3">
            <div className="col-xl-6 col-lg-6">
              <div className="">
                <b> Nome do Empreendimento </b>
                <Tooltip target=".custom-target-icon" />
                <i
                  className="custom-target-icon pi pi-info-circle p-text-secondary"
                  data-pr-tooltip="Edite por aqui o nome do seu empreendimento"
                  style={{ cursor: "pointer" }}
                ></i>
              </div>
              <Input
                name="title"
                control={form.control}
                label={
                  loadingEnterprise ? "Carregando..." : "Nome do Empreendimento"
                }
                errors={errors}
              />
            </div>
            <div className="col-lg-6">
              <div className="">
                <b> Nº Matricula Empreendimento </b>
                <Tooltip target=".custom-target-icon" />
                <i
                  className="custom-target-icon pi pi-info-circle p-text-secondary"
                  data-pr-tooltip="Edite por aqui o Número da Matricula do Empreendimento"
                  style={{ cursor: "pointer" }}
                ></i>
              </div>
              <Input
                name="matricula"
                control={form.control}
                label={loadingEnterprise ? "Carregando..." : "N° da Matrícula"}
                errors={errors}
              />
            </div>
            <div className="col-lg-6 mt-3">
              <div className="pb-2">
                <b> Índice Reajuste </b>
                <Tooltip target=".custom-target-icon" />
                <i
                  className="custom-target-icon pi pi-info-circle p-text-secondary"
                  data-pr-tooltip="Selecione o índice de reajuste que utiliza no empreendimento"
                  style={{ cursor: "pointer" }}
                ></i>
              </div>
              <Select
                name="index_id"
                label={loadingIndex ? "Carregando..." : "Índice Reajuste"}
                errors={errors}
                preValue={defaultValues && defaultValues.index_id}
                control={form.control}
                options={
                  index &&
                  index.map((dado) => ({
                    value: dado.id,
                    label: dado.name,
                  }))
                }
              />
            </div>
            {permissions?.includes("195") && (
              <>
                <div className="col-lg-6 my-3 form-group">
                  <div className="pb-2">
                    <b> Exibir no app </b>
                    <Tooltip target=".custom-target-icon" />
                    <i
                      className="custom-target-icon pi pi-info-circle p-text-secondary"
                      data-pr-tooltip="Selecione o ícone abaixo para exibir o empreendimento no app"
                      style={{ cursor: "pointer" }}
                    ></i>
                  </div>
                  <div className="mt-3">
                    <Toggle
                      name="show_app"
                      onLabel="Exibir no app"
                      offLabel="Exibir no app"
                      preValue={defaultValues && defaultValues.show_app}
                      control={form.control}
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                </div>
                <div className="col-lg-6 form-group">
                  <div className="pb-2">
                    <b> Exibir documentos no app </b>
                    <Tooltip target=".custom-target-icon" />
                    <i
                      className="custom-target-icon pi pi-info-circle p-text-secondary"
                      data-pr-tooltip="Selecione o ícone abaixo para exibir os documentos do empreendimento no app"
                      style={{ cursor: "pointer" }}
                    ></i>
                  </div>
                  <div className="">
                    <Toggle
                      name="show_files_app"
                      onLabel="Exibir documentos no app"
                      offLabel="Exibir documentos no app"
                      preValue={defaultValues && defaultValues.show_files_app}
                      control={form.control}
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        <hr className="my-4" />
        <div className="col-lg-12 text-end">
          <Button
            rounded
            type="submit"
            label="Editar"
            iconPos="right"
            loading={loading}
            className="p-inputtext-sm m-auto"
            icon="fa-solid fa-circle-chevron-right"
          />
        </div>
      </form>
    </>
  );
}
